import { Tag, Timer } from "lucide-react";

// Blocks that only make sense inside the Platform Admin popup builder (not
// the tenant email/campaign builder) — kept in a separate file so the shared
// emailBlocks.jsx (used by every tenant's campaign builder) is never touched.
export const POPUP_BLOCK_DEFS = [
  { type: "promoCode", label: "Promo Code", icon: Tag },
  { type: "countdownTimer", label: "Countdown Timer", icon: Timer },
];

export const POPUP_BLOCK_TYPES = new Set(POPUP_BLOCK_DEFS.map((d) => d.type));

function uid() {
  return `blk-${Math.random().toString(36).slice(2, 10)}`;
}

export function makePopupBlock(type) {
  if (type === "promoCode") {
    return { id: uid(), type, label: "Special Offer", code: "SAVE20", discountPercent: 20, appliesTo: "both" };
  }
  if (type === "countdownTimer") {
    return { id: uid(), type, label: "Offer ends in:", targetAt: "" };
  }
  return null;
}

function esc(s) {
  return String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}

const APPLIES_LABELS = { credits: "AI Credits Top-Up", seats: "Subscription Seats", both: "AI Credits & Subscription Seats" };

// Static HTML for the builder canvas + iframe preview only. The real,
// interactive version (working Copy button / live ticking countdown) is
// rendered as actual React in PopupModal.jsx.
export function renderPopupBlockPreview(b) {
  if (b.type === "promoCode") {
    return `<div style="text-align:center;padding:18px 12px;">
      <div style="font-size:14px;font-weight:600;color:#0f172a;margin-bottom:10px;">${esc(b.label)}</div>
      <div style="display:inline-block;border:2px dashed #2563eb;border-radius:10px;padding:12px 26px;font-size:22px;font-weight:800;letter-spacing:3px;color:#2563eb;background:#eff6ff;">${esc(b.code)}</div>
      <div style="margin-top:8px;font-size:12.5px;color:#64748b;">${esc(b.discountPercent)}% off &middot; ${esc(APPLIES_LABELS[b.appliesTo] || APPLIES_LABELS.both)}</div>
      <div style="margin-top:12px;"><span style="display:inline-block;background:#2563eb;color:#fff;font-size:13px;font-weight:600;padding:9px 18px;border-radius:7px;">Copy Code</span></div>
    </div>`;
  }
  if (b.type === "countdownTimer") {
    return `<div style="text-align:center;padding:18px 12px;">
      <div style="font-size:13px;color:#64748b;margin-bottom:10px;">${esc(b.label)}</div>
      <div style="font-size:26px;font-weight:800;color:#0f172a;letter-spacing:2px;font-family:monospace;">02 : 14 : 33 : 07</div>
      <div style="margin-top:4px;font-size:10.5px;color:#94a3b8;letter-spacing:1px;">DAYS &nbsp; HRS &nbsp; MIN &nbsp; SEC</div>
    </div>`;
  }
  return "";
}
